import { Action } from 'redux'
import { createActions, createReducer } from 'reduxsauce'

import {
	IActionsFromCreators,
	ILocaleActionCreators
} from '../../interfaces/action'
import { ILocale } from '../../interfaces/token'

/**
 * Action types & creators
 */
export const { Types, Creators }: IActionsFromCreators<ILocaleActionCreators> =
	createActions({
		setCountry: ['country'],
		resetCountry: []
	})

/**
 * Handlers
 */

export const INITIAL_STATE: ILocale = {
	userCountry: '',
	isNational: false
}

const set = (state = INITIAL_STATE, action: any) => {
	return {
		userCountry: action.country,
		isNational: action.country === 'Brazil'
	}
}
const reset = (state = INITIAL_STATE, action: any) => INITIAL_STATE

/**
 * Reducer
 */
export default createReducer<ILocale, Action<ILocaleActionCreators>>(
	INITIAL_STATE,
	{
		[Types.SET_COUNTRY]: set,
		[Types.RESET_COUNTRY]: reset
	}
)
